import React from "react";
import { Typography, Divider, List, Card } from "antd";
import { StyledPrivacyPolicy } from "../PrivacyPolicy/styles";
import { APP_EMAIL } from "../../../utils/AiService/constant";

const { Title, Paragraph, Text } = Typography;

const GDPRPolicy = () => {
  return (
    <StyledPrivacyPolicy>
      <div className="privacy-container">
        <Card className="privacy-card">
          <Title level={2} className="privacy-title">
            GDPR Policy
          </Title>

          <Text className="last-updated">Last updated: February 2026</Text>

          <Divider />

          {/* 1 */}
          <section className="privacy-section">
            <Title level={4}>1. OUR COMMITMENT</Title>
            <Paragraph>
              Kelu is committed to protecting personal data in line with:
            </Paragraph>
            <List
              dataSource={[
                "UK General Data Protection Regulation (UK GDPR)",
                "Data Protection Act 2018",
                "ICO guidance",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* 2 */}
          <section className="privacy-section">
            <Title level={4}>2. DATA CONTROLLER vs PROCESSOR</Title>

            <Paragraph strong>DATA CONTROLLER for:</Paragraph>
            <List
              dataSource={[
                "Data of our customers (businesses who use Kelu)",
                "Website visitor data",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />

            <Paragraph strong style={{ marginTop: 16 }}>
              DATA PROCESSOR for:
            </Paragraph>
            <List
              dataSource={[
                "End-user data (your customers' messages and information)",
                "We process this data on your behalf, under your instructions",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* 3 */}
          <section className="privacy-section">
            <Title level={4}>3. LAWFUL BASIS FOR PROCESSING</Title>
            <Paragraph>We process data under these lawful bases:</Paragraph>
            <List
              dataSource={[
                "Contract: To deliver the service you've paid for",
                "Legal obligation: To comply with UK law",
                "Legitimate interests: To improve and secure our platform",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* 4 */}
          <section className="privacy-section">
            <Title level={4}>4. DATA PROCESSING AGREEMENT (DPA)</Title>
            <Paragraph>
              As a business using Kelu to process your customers' data, you may
              require a Data Processing Agreement.
            </Paragraph>
            <Paragraph>
              Email <strong>{APP_EMAIL}</strong> to request a DPA.
            </Paragraph>
            <Paragraph>We will provide one within 5 business days.</Paragraph>
          </section>

          {/* 5 */}
          <section className="privacy-section">
            <Title level={4}>5. DATA TRANSFERS</Title>
            <Paragraph>All data is stored in the UK or EU.</Paragraph>
            <Paragraph>
              We do not transfer data outside UK/EU without appropriate
              safeguards.
            </Paragraph>
          </section>

          {/* 6 */}
          <section className="privacy-section">
            <Title level={4}>6. DATA RETENTION</Title>
            <List
              dataSource={[
                "Active accounts: Data retained while account is active",
                "Deleted accounts: Data purged within 30 days",
                "Backups: Purged within 90 days",
                "Financial records: 7 years (legal requirement)",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* 7 */}
          <section className="privacy-section">
            <Title level={4}>7. SECURITY MEASURES</Title>
            <Paragraph>We protect your data with:</Paragraph>
            <List
              dataSource={[
                "SSL/TLS encryption in transit",
                "Encryption at rest",
                "Access controls and authentication",
                "Regular security reviews",
                "Staff data protection training",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* 8 */}
          <section className="privacy-section">
            <Title level={4}>8. DATA BREACH PROCEDURE</Title>
            <Paragraph>In the event of a data breach:</Paragraph>
            <List
              dataSource={[
                "We will notify affected customers within 72 hours",
                "We will report to ICO if required",
                "We will document all breaches",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
          </section>

          {/* 9 */}
          <section className="privacy-section">
            <Title level={4}>9. YOUR RIGHTS</Title>
            <Paragraph>Under UK GDPR you have the right to:</Paragraph>
            <List
              dataSource={[
                "Access (Subject Access Request)",
                "Rectification",
                "Erasure",
                "Restriction of processing",
                "Data portability",
                "Object to processing",
              ]}
              renderItem={(item) => <List.Item>- {item}</List.Item>}
            />
            <Paragraph>
              Submit requests to: <strong>{APP_EMAIL}</strong>
            </Paragraph>
            <Paragraph>Response within 30 days, free of charge.</Paragraph>
          </section>

          {/* 10 */}
          <section className="privacy-section">
            <Title level={4}>10. DATA PROTECTION OFFICER</Title>
            <Paragraph>
              At our current size, we are not required to appoint a DPO.
            </Paragraph>
            <Paragraph>
              For all data protection matters, contact:
              <strong> {APP_EMAIL}</strong>
            </Paragraph>
          </section>

          {/* 11 */}
          <section className="privacy-section">
            <Title level={4}>11. SUPERVISORY AUTHORITY</Title>
            <Paragraph>UK supervisory authority:</Paragraph>
            <Paragraph>Information Commissioner's Office (ICO)</Paragraph>
          </section>
          <Divider />
          <Paragraph>ico.org.uk | 0303 123 1113</Paragraph>
          <Paragraph>
            Questions? Email: <strong>{APP_EMAIL}</strong>
          </Paragraph>
        </Card>
      </div>
    </StyledPrivacyPolicy>
  );
};

export default GDPRPolicy;
